import axios from 'axios'
import CreateTenantInput from './dto/createTenantInput'
import CreateTenantOutput from './dto/createTenantOutput'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedTenantResultRequestDto} from './dto/PagedTenantResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import {GetAllTenantOutput} from './dto/getAllTenantOutput'
import UpdateTenantInput from './dto/updateTenantInput'
import UpdateTenantOutput from './dto/updateTenantOutput'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Tenant/Create`
export const URL_DELETE = `${API_URL}/Tenant/Delete`
export const URL_GET = `${API_URL}/Tenant/Get`
export const URL_GET_ALL = `${API_URL}/Tenant/GetAll`
export const URL_UPDATE = `${API_URL}/Tenant/Update`

export function onCreateTenant(createTenantInput: CreateTenantInput): Promise<CreateTenantOutput> {
  return axios.post(URL_CREATE, createTenantInput)
}

export function onDeleteTenant(entityDto: EntityDto) {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetTenant(entityDto: EntityDto) {
  return axios.get(URL_GET, {params: entityDto})
}

export function getAllTenants(
  pagedFilterAndSortedRequest: PagedTenantResultRequestDto
): Promise<PagedResultDto<GetAllTenantOutput>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateTenant(updateTenantInput: UpdateTenantInput): Promise<UpdateTenantOutput> {
  return axios.put(URL_UPDATE, updateTenantInput)
}
